import { render, staticRenderFns } from "./m-blockItem.vue?vue&type=template&id=2b3794de&scoped=true&"
import script from "./m-blockItem.vue?vue&type=script&lang=ts&"
export * from "./m-blockItem.vue?vue&type=script&lang=ts&"
import style0 from "./m-blockItem.vue?vue&type=style&index=0&id=2b3794de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3794de",
  null
  
)

export default component.exports